/**
 * @generated SignedSource<<6b660748fcd82db11fbfc933c9a254d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReceivecustomerpaymentPayload",
    "kind": "LinkedField",
    "name": "receivecustomerpayment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReceivePaymentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReceivePaymentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d30e138816d0e37b95986dc6a3c92138",
    "id": null,
    "metadata": {},
    "name": "ReceivePaymentMutation",
    "operationKind": "mutation",
    "text": "mutation ReceivePaymentMutation(\n  $input: ReceivecustomerpaymentInput!\n) {\n  receivecustomerpayment(input: $input) {\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "a63a0741b823c3aa9e27d26060d49c88";

module.exports = node;
